module.exports = __webpack_public_path__ + "img/noAccess.e17f61be.png";